import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import axios from "axios"
import "./loopingTask.css" 
import "./loopingTaskDark.css" 
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'
import { Switch } from '@chakra-ui/react'
import { useSelector } from 'react-redux';
const months = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь"
  ];
  
  


export default  function LoopingTask({setChecked,checked,selectDays,setselectDays,loopingStartDate,setloopingStartDate,everythreedays,seteverythreedays,creatTaskadminInfo}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const getDarkModoe = useSelector(darkModes => darkModes)
  const gerChekcedCompany = useSelector((allWorkers) => allWorkers);

  const sendForTreeDays = (e) => {
    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentDate = new Date();
    const localTime = new Date(currentDate.toLocaleString('en-US', { timeZone: localTimeZone }));
  
    if (e === "everythreedays") {
      localTime.setDate(localTime.getDate() + 3);

      seteverythreedays(localTime)
    }
  }
  

  
  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}
               <div className='onOffLoopingTaskViev' style={{marginTop:"20px"}}>
                        <Switch size='lg'  isChecked={checked} onChange={()=> [setChecked(check => !check),setShow(!show)]}/>
                        <p>Повтор задачи</p>
                </div>

      <Modal show={show} onHide={handleClose} size='full'  className={getDarkModoe.ToggleDarkModeReducer.chekced ? "taskloopModalDark" : "taskloopModal"}>
        <Modal.Header >
        
        </Modal.Header>
        <Modal.Body>
                <div className='infoCreatorForloop'>
                  
                    <div>
                            <p style={{color:"#3B79F6",fontSize:"24px"}}>Название задачи</p>
                            <p style={{fontSize:"24px"}}>Создатель: {creatTaskadminInfo?.name?creatTaskadminInfo?.name:"Без имени"}</p>
                            <p style={{fontSize:"20px"}}>Дата создания:  {new Date().getMonth()} {months[new Date().getMonth()]}</p>
                    </div>
                    <Avatar size='xl' name={creatTaskadminInfo?.name} src={creatTaskadminInfo?.img?"https://xn--h1alceggc.xn--p1ai/"+creatTaskadminInfo?.img:""} />
                    {/* face */}
                    {/* <Avatar size='xl' name={creatTaskadminInfo?.name} src={creatTaskadminInfo?.img?"http://localhost:5000/"+creatTaskadminInfo?.img:""} /> */}
                </div>
                <div className='changeDateForLoop'>
                        <p>Дата начала</p>
                        <input type="datetime-local" name="datetime"  defaultValue={loopingStartDate} onChange={(e)=> setloopingStartDate(e.target.value)}/>
                </div>
               
                <div className='loopTaskSelect'>
                        <p>Повторения:</p>
                        <select name="" id="" defaultValue={selectDays} onChange={(e)=> [ setselectDays(e.target.value),console.log(e.target.value),sendForTreeDays(e.target.value)]}>
                                <option value="everyDay">Каждый день</option>
                                <option value="EveryWeek">Каждую неделю</option>
                                <option value="everymonth">Каждый месяц</option>
                                <option value="EveryYear">Каждый год</option>
                                <option value="everythreedays">Каждые три дня</option>
                                
                        </select>
                </div>
                <div className='onOffLoopingTask'>
                <p>Повтор задачи</p>
                        <Switch size='lg'  isChecked={checked} onChange={()=> setChecked(check => !check)}/>
                       
                </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='closeLoopModal' onClick={handleClose}>
          Закрыть
          </button>
         
        </Modal.Footer>
      </Modal>
    </>
  );
}
